import { CASE_META_ACTIONS } from "constants";

export function updateCaseMeta(caseId, companyId, data) {
    return {
        type: CASE_META_ACTIONS.UPDATE_CASE_META,
        payload: {
            caseId,
            companyId,
            data
        }
    };
}

export function updatedCaseMeta(caseId) {
    return {
        type: CASE_META_ACTIONS.UPDATED_CASE_META,
        payload: {
            caseId
        }
    };
}
export function failedUpdateCaseMeta(caseId) {
    return {
        type: CASE_META_ACTIONS.FAILED_UPDATE_CASE_META,
        payload: {
            caseId
        }
    };
}

export function resetCaseMeta(caseId) {
    return {
        type: CASE_META_ACTIONS.RESET_CASE_META,
        payload: {
            caseId
        }
    };
}